import { useQueryClient } from '@tanstack/react-query'
import { FEEDBACK_SURVEY, EXTRA_SLOTS } from '@tfa/shared'
import { useAuth } from '../../hooks/useAuth'
import { api } from '../../services/api'
import { SurveyFlowSheet } from './SurveyFlowSheet'
import { surveyDraftKey } from '../../utils/surveyDraft'

interface Props {
  open: boolean
  onClose: () => void
  curator?: { name?: string | null; avatarUrl?: string | null } | null
}

/** Род обращения по полу (нейтральный фолбэк — мужской). */
function gz(gender: string | null | undefined, male: string, female: string): string {
  return gender === 'FEMALE' ? female : male
}

/**
 * Промежуточная анкета ОС (экватор, неделя 6) — #PRD.
 * Тонкая обёртка над SurveyFlowSheet: festive-интро, вопросы, +2 TuCoin.
 */
export function FeedbackSurveySheet({ open, onClose, curator }: Props) {
  const qc = useQueryClient()
  const { user } = useAuth()
  const firstName = (user as { firstName?: string } | undefined)?.firstName || 'друг'
  const gender = (user as { gender?: string | null } | undefined)?.gender ?? null

  return (
    <SurveyFlowSheet
      open={open}
      onClose={onClose}
      curator={curator}
      questions={FEEDBACK_SURVEY}
      reward={EXTRA_SLOTS.FEEDBACK.tucoin}
      introTitle={`${firstName}, ты с нами уже 6 недель!`}
      introBody="Мы гордимся, что ты продолжаешь работать над собой. Помоги нам улучшить школу ТФА — заполни короткую анкету и продолжи работу."
      introTimeLabel="до 5 минут"
      draftKey={user?.id ? surveyDraftKey('FEEDBACK', user.id) : undefined}
      outroTitle={`${firstName}, спасибо за обратную связь!`}
      outroBody={`${gz(gender, 'Ты помог', 'Ты помогла')} нам стать лучше.`}
      submit={async (answers) => {
        await api.submitFeedback(answers)
        qc.invalidateQueries({ queryKey: ['surveyStatus'] })
        qc.invalidateQueries({ queryKey: ['dashboard'] })
      }}
    />
  )
}
